import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Alert,
} from '@mui/material';
import { listAppointments } from '../../services/appointmentService';
import { useAuth } from '../../contexts/AuthContext';

const PhysicianScheduleModal = ({ open, onClose, physician }) => {
  const { profile } = useAuth();
  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSchedule = async () => {
      if (!open || !physician || !profile?.tenant_id) return;
      setLoading(true);
      setError(null);
      try {
        const { data, error } = await listAppointments({
          tenantId: profile.tenant_id,
          physicianId: physician.id,
          status: 'scheduled', // Only show upcoming
        });
        if (error) throw error;
        setSchedule(data);
      } catch (err) {
        setError('Failed to load schedule.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSchedule();
  }, [open, physician, profile?.tenant_id]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Upcoming Schedule for Dr. {physician?.first_name} {physician?.last_name}
      </DialogTitle>
      <DialogContent>
        {loading && <Typography>Loading...</Typography>}
        {error && <Alert severity="error">{error}</Alert>}
        {!loading && !error && schedule.length === 0 && (
          <Typography sx={{ mt: 2 }}>No upcoming appointments found for this physician.</Typography>
        )}
        {!loading && !error && schedule.length > 0 && (
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Patient</TableCell>
                  <TableCell>Type</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {schedule.map((appt) => (
                  <TableRow key={appt.id}>
                    <TableCell>{new Date(appt.scheduled_at).toLocaleString()}</TableCell>
                    <TableCell>{`${appt.patient.first_name} ${appt.patient.last_name}`}</TableCell>
                    <TableCell>{appt.type}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PhysicianScheduleModal;
